// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4c977d29","610":"9dc7e712","703":"15df19bb","787":"7ba9096f"}[chunkId] + ".chunk.js";
};